export const AUTH_ME = '/auth/me';
export const AUTH_LOGOUT = '/auth/logout';
export const AUTH_TOKEN = '/auth/token';
export const BUKUPEMBANTUS = '/bukupembantus';
export const TEMPLATES = '/templates';
export const AKUNS = '/akuns';
export const BACKUP_DATABASE = '/backup/database';
export const BEBANS = '/bebans';
export const CASHFLOWS = '/cashflows';
export const IMAGES = '/images';
export const REPORTS_SUMMARYAKUN = '/reports/summaryakun';
export const REPORTS_GRAPH_BAR = '/reports/graph/bar';
export const REPORTS_GRAPH_DOUGHNUT = '/reports/graph/doughnut';
export const REPORTS_NERACA = '/reports/neraca';
export const CREDENTIALS = '/credentials';
export const HUTANGS = '/hutangs';
export const INVENTORIES = '/inventories';
export const PIUTANGS = '/piutangs';








